import React, { useState } from "react";
import ButtonRequire from "../../components/Button/ButtonRequire";
import axios from "axios";
import { HEADER } from "../../utils/Utils";
import _ from "lodash";

export default function PinSetupFragment({ dataUser, setFragment }) {
  const [inputPin, setInputPin] = useState({
    pin: "",
    pin_verify: "",
  });
  const handleChange = (e) => {
    const { value } = e.target;

    // Remove non-numeric characters using regular expression
    const numericValue = value.replace(/\D/g, "");

    // Limit the input length to 6
    const maxLengthValue = numericValue.slice(0, 6);

    setInputPin((prevState) => ({
      ...prevState,
      [e.target.name]: maxLengthValue,
    }));
  };

  async function SavePin(e) {
    e.preventDefault();
    await axios
      .get(
        `${process.env.REACT_APP_BASE_URL_API}/dompetKartiniPin?akuisisi_id=${dataUser.akuisisi_id}`,
        {
          headers: HEADER,
        }
      )
      .then((res) => {
        if (!_.isEmpty(res.data.data)) {
          let dompet_kartini_pin_id = res.data.data[0].dompet_kartini_pin_id;
          axios
            .put(
              `${process.env.REACT_APP_BASE_URL_API}/dompetKartiniPin/${dompet_kartini_pin_id}`,
              {
                dompet_kartini_pin_id: dompet_kartini_pin_id,
                pin_code: inputPin.pin,
                pin_status: "active",
                akuisisi_id: dataUser.akuisisi_id,
              },
              { headers: HEADER }
            )
            .then((res) => {
              setFragment("policy-agreement");
            })
            .catch((error) => console.error(error));
        } else {
          axios
            .post(
              `${process.env.REACT_APP_BASE_URL_API}/dompetKartiniPin`,
              {
                pin_code: inputPin.pin,
                pin_status: "active",
                akuisisi_id: dataUser.akuisisi_id,
              },
              { headers: HEADER }
            )
            .then((res) => {
              setFragment("policy-agreement");
            })
            .catch((error) => console.error(error));
        }
      });
  }

  return (
    <div>
      <h2 className="font-medium text-gray-700">E-Wallet Details</h2>
      <form className="mt-4 space-y-3">
        <input
          name="pin"
          className="form-input w-full h-12 disabled:text-gray-400"
          placeholder="Input Pin (6 Digit Number)"
          type="text"
          value={inputPin.pin}
          onChange={handleChange}
        />
        <div className="relative">
          <input
            name="pin_verify"
            className="form-input w-full pr-6 h-12 disabled:text-gray-400"
            placeholder="Repeat Pin"
            type="text"
            value={inputPin.pin_verify}
            onChange={handleChange}
          />
          <div className="absolute inset-0 left-auto flex items-center pointer-events-none">
            <span className="text-sm text-gray-400 font-medium px-3">
              {inputPin.pin === inputPin.pin_verify &&
              inputPin.pin_verify.length === 6
                ? "✅"
                : "❌"}
            </span>
          </div>
        </div>
        <ButtonRequire
          title="Confirm PIN"
          functionOnClick={SavePin}
          isDisabled={
            _.isEmpty(inputPin.pin) ||
            inputPin.pin !== inputPin.pin_verify ||
            inputPin.pin_verify.length !== 6
          }
        />
      </form>
    </div>
  );
}
